import { GetPartsSelection, PutPartsSelection } from '../../services/apiTypes';
import {
  createHeaderWithCredentials,
  fetchWithAuth,
  getApiUrl,
  getHeader,
} from '../../services/apiUtils';

export interface PartsSelectionParam {
  rmaNo: string;
}

const endPoint = 'parts-selection';

export const fetchPartsSelection = async (
  params: PartsSelectionParam,
): Promise<GetPartsSelection> => {
  const queryParams = new URLSearchParams();
  queryParams.append('rmaNo', params.rmaNo);
  const apiUrl = getApiUrl(endPoint);
  const url = `${apiUrl}?${queryParams.toString()}`;
  const header = getHeader({
    method: 'GET',
  });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );
  return response.data;
};

export const updatePartsSelection = async (
  newPartsSelection: PutPartsSelection,
): Promise<void> => {
  const url = getApiUrl(endPoint);
  const header = getHeader({
    method: 'PUT',
    body: JSON.stringify(newPartsSelection),
    contentType: 'application/json',
  });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};
